import { useTheme } from '@mui/material';

import type { TimeSeriesPointCustom } from '@/components/Chart/utils/buildChartLineSeries';
import { createTooltip } from '@/components/Chart/utils/createTooltip';
import useDateText, { DateTextVariants } from '@/components/DateText/useDateText';

import type { Point } from 'highcharts';
import type Highcharts from 'highcharts/highstock';

const createHeader = () =>
  '<div style="display: flex; flex-direction: column; width:350px;">' +
  '<div style="font-size: 8px; display: flex; font-weight: 400;justify-content: space-between;">' +
  '<div style="width: 40%;">Short Title</div>' +
  '<div style="width: 20%;padding-left: 8px; padding-right: 8px;">PeriodAbs</div>' +
  '<div style="width: 20%;padding-left: 8px; padding-right: 8px;">Transaction Date</div>' +
  '<div style="width: 20%;"></div>' +
  '</div>';

const useForwardCurveTooltipFormatter = () => {
  const { formatDateString } = useDateText();
  const theme = useTheme();

  const createBodyRow = (point: Point, custom: TimeSeriesPointCustom, value: string) => {
    const transactionDate = custom.transactionDate
      ? formatDateString(new Date(custom.transactionDate).toJSON(), DateTextVariants.FULL)
      : '';
    const nameColumn = `<div style="width: 40%; padding-right: 8px; border-right: 1px solid gray; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;">${point.series.name}</div>`;
    return (
      `<div style="font-size: 10px; font-style: normal;font-weight: 500;justify-content: space-between;height: 19px; display: flex;">${
        nameColumn
      }<div style="width: 20%; padding-left: 8px; padding-right: 8px;">${
        custom?.periodAbs ?? ''
      }</div>` +
      `<div style="width: 20%; padding-left: 8px; border-left: 1px solid gray; ">${
        transactionDate
      }</div>` +
      `<div style="height 19px; width: 20%; padding-left:8px; padding-top:3px"><div style="background-color:${
        point.series.color ?? '#F8F8F8'
      }; color:${
        theme.palette.background.default
      }; font-size:10px; line-height:13px; height:14px; padding-left:4px; padding-right:4px; text-align: start;">${
        value
      }</div></div></div>`
    );
  };

  const createTooltipFormatter = (
    allChartSeries: Highcharts.Series[],
    hoveredPointXValue: string | number | undefined
  ) => {
    return createTooltip(allChartSeries, hoveredPointXValue, createHeader, createBodyRow);
  };
  return { createTooltipFormatter };
};

export default useForwardCurveTooltipFormatter;
